import { Pressable, StyleSheet, Text, View } from 'react-native';
import CardLinkAction from 'src/presentation/components/molecules/CardLinkAction';
import Colors from 'src/core/utils/Colors';
import Fonts from 'src/core/utils/Fonts';
import Dimens from 'src/core/utils/Dimens';
import Styles from 'src/core/utils/Styles';
import ThermenImage from 'src/presentation/components/molecules/ThermenImage';
import type { ApiProductFeaturedItem } from 'src/core/models/api/ApiFeaturedItem';
import type { FC } from 'react';
import { useFeaturedItemStore } from 'src/domain/stores/useFeaturedItemStore';
import Translations from 'src/core/utils/Translations';

type Props = {
	item: ApiProductFeaturedItem;
	width: number;
	height: number;
};

const ProductFeaturedItem: FC<Props> = ({ item, width, height }: Props) => {
	const { open } = useFeaturedItemStore();

	const openDetail = () => open(item);

	return (
		<View style={[styles.featuredCard, Styles.card.shadowSoft, { width, height }]}>
			<Pressable style={styles.featuredLayout} onPress={openDetail}>
				<View style={styles.featuredImageFrame}>
					<ThermenImage source={item.image ? { uri: item.image } : null} style={styles.featuredImage} />
				</View>
				<View style={styles.featuredContainer}>
					<View style={styles.featuredContent}>
						<Text style={styles.featuredWorkspaceText}>{item.workspace_name}</Text>
						<Text style={styles.featuredArrangementTitle}>{item.name}</Text>
					</View>
					{item.price ? (
						<View style={styles.featuredFooter}>
							<Text style={styles.featuredPriceFromText}>{Translations.startingFromShort}</Text>
							<Text style={styles.featuredPriceText}>{item.price}</Text>
						</View>
					) : null}
				</View>
			</Pressable>
			<View style={styles.featuredAction}>
				<CardLinkAction label={Translations.moreInfo} onLight={true} onPress={openDetail} />
			</View>
		</View>
	);
};

const styles = StyleSheet.create({
	featuredContainer: {
		paddingVertical: Dimens.padding16,
		paddingHorizontal: Dimens.padding24,
		flexGrow: Dimens.flex1,
		flexShrink: Dimens.flex0,
		justifyContent: 'space-between',
	},
	featuredWorkspaceText: {
		fontFamily: Fonts.barlow,
		fontSize: Dimens.fontSize15,
		paddingBottom: Dimens.padding10,
	},
	featuredArrangementTitle: {
		fontFamily: Fonts.ptSerif,
		fontSize: Dimens.fontSize22,
		paddingBottom: Dimens.padding10,
	},
	featuredPriceFromText: {
		color: Colors.black,
		fontSize: Dimens.fontSize14,
	},
	featuredPriceText: {
		fontSize: Dimens.fontSize23,
		fontWeight: Dimens.fontWeight700,
		color: Colors.black,
	},
	featuredCard: {
		borderRadius: Dimens.borderRadius4,
		backgroundColor: Colors.white,
	},
	featuredLayout: {
		flex: Dimens.flex1,
		justifyContent: 'space-between',
	},
	featuredImageFrame: {
		height: Dimens.size210,
		flexShrink: Dimens.flex0,
	},
	featuredImage: {
		width: '100%',
		height: '100%',
		borderTopLeftRadius: Dimens.borderRadius4,
		borderTopRightRadius: Dimens.borderRadius4,
		backgroundColor: Colors.gray400,
	},
	featuredContent: {
		flexGrow: Dimens.flex1,
		flexShrink: Dimens.flex0,
	},
	featuredFooter: {
		gap: Dimens.gap10,
	},
	featuredAction: {
		paddingHorizontal: Dimens.padding24,
		paddingBottom: Dimens.padding24,
	},
});

export default ProductFeaturedItem;
